import { render, staticRenderFns } from "./EmployeeInactivityTable.vue?vue&type=template&id=6ee13297&"
import script from "./EmployeeInactivityTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeInactivityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports